/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";

//
// ###########################################################################
//
const DatosServicio = ({ articulo, showPrecio = true }) => {

  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Servicio
              </Typography>

              <Grid container spacing={2}>
                <Item label="Descripción" value={articulo.descripcion} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosServicio;
